import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const BATCH_NUMBERS_REQUEST =
  "schoolconnect/batchNumbers/BATCH_NUMBERS_REQUEST";
export const BATCH_NUMBERS_SUCCESS =
  "schoolconnect/batchNumbers/BATCH_NUMBERS_SUCCESS";
export const BATCH_NUMBERS_FAILURE =
  "schoolconnect/batchNumbers/BATCH_NUMBERS_FAILURE";
export const CLEAR_BATCH_NUMBERS =
  "schoolconnect/batchNumbers/CLEAR_BATCH_NUMBERS";

const initialState = {
  fetching: false,
  error: null,
  errorResponse: null,
  index: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case BATCH_NUMBERS_REQUEST:
      return { ...state, fetching: true, error: null };
    case BATCH_NUMBERS_SUCCESS:
      const { results, commodityIds } = action.data;

      const batchNosPerCommodityId = commodityIds.reduce((acc, cur) => {
        return {
          ...acc,
          [cur]: results.filter((item) =>
            item.store_commodity_ids.includes(cur)
          ),
        };
      }, {});

      return {
        ...state,
        fetching: false,
        index: { ...state.index, ...batchNosPerCommodityId },
        error: null,
      };
    case BATCH_NUMBERS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error.message,
        errorResponse: action.error.response,
      };
    case CLEAR_BATCH_NUMBERS:
      return {
        ...state,
        index: {},
      };
    default:
      return state;
  }
}

const persistedReducer = persistReducer(
  {
    key: "batch-numbers",
    storage,
    blacklist: ["error", "errorResponse", "fetching"],
  },
  reducer
);

export default persistedReducer;

export const clearBatchNumberOptions = () => ({
  type: CLEAR_BATCH_NUMBERS,
});

export const requestBatchNumbers = (commodityIds, iso2, date) => ({
  type: BATCH_NUMBERS_REQUEST,
  commodityIds,
  iso2,
  date,
});

export function* batchNumbersSagaWatcher() {
  yield takeLatest(BATCH_NUMBERS_REQUEST, batchNumbersSagaWorker);
}

// Builds the query string shared by the saga fetch and the search used by
// the batch number type-ahead. destination_location (adm_1) filtering was
// never finished on the backend side, so it's left out here on purpose.
function buildBatchNumbersUrl({ commodityIds, iso2, date, search }) {
  const params = new URLSearchParams();
  if (commodityIds?.length) {
    params.set("core_commodity__in", commodityIds.join(","));
  }
  if (iso2) {
    params.set("destination_country_iso2", iso2.toUpperCase());
  }
  if (date) {
    params.set("dispatched_year_month", date);
  }
  if (search) {
    params.set("search", search);
  }
  return `${process.env.REACT_APP_API_URL}/batch-numbers/?${params.toString()}`;
}

function fetchBatchNumbers(action) {
  const { commodityIds, iso2, date } = action;

  return axios({
    method: "GET",
    url: buildBatchNumbersUrl({ commodityIds, iso2, date }),
  });
}

// Plain promise-based fetch for the batch number type-ahead, so it can be
// used directly as a react-select `loadOptions` without going through redux.
export function searchBatchNumbers({ commodityIds, iso2, date, search }) {
  return axios
    .get(buildBatchNumbersUrl({ commodityIds, iso2, date, search }))
    .then((response) => response.data.results);
}

function* batchNumbersSagaWorker(action) {
  try {
    const response = yield call(fetchBatchNumbers, action);
    const data = {
      results: response.data.results,
      commodityIds: action.commodityIds,
    };
    yield put({
      type: BATCH_NUMBERS_SUCCESS,
      data,
    });
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put({
      type: BATCH_NUMBERS_FAILURE,
      error,
    });
  }
}

export const getBatchNumbers = (state) => state["batch-numbers"].index;
export const getBatchNumbersIsFetching = (state) =>
  state["batch-numbers"].fetching;
